import { useCallback, useState } from 'react';

import ConfirmationDialog from '@sayyesschool/frontend/components/confirmation-dialog';
import FormDialog from '@sayyesschool/frontend/components/form-dialog';
import PageSection from '@sayyesschool/frontend/components/page-section';
import { useSectionExercises } from '@sayyesschool/frontend/features/courses';
import { useBoolean } from '@sayyesschool/frontend/hooks/state';

import ExerciseForm from '../exercise-form';
import ExercisesList from '../exercises-list';

export default function SectionExercises({
    section,
    onReorder
}) {
    const [exercises, actions] = useSectionExercises(section);

    const [exercise, setExercise] = useState();
    const [isFormOpen, toggleFormOpen] = useBoolean(false);
    const [isConfirmationDialogOpen, toggleConfirmationDialogOpen] = useBoolean(false);

    const handleCreate = useCallback(() => {
        const data = {
            courseId: section.courseId,
            sectionId: section.id
        };

        return actions.createExercise(data)
            .finally(() => {
                toggleFormOpen(false);
            });
    }, [section, actions, toggleFormOpen]);

    const handleDelete = useCallback(() => {
        return actions.deleteExercise(exercise.id, section.courseId)
            .finally(() => toggleConfirmationDialogOpen(false));
    }, [section, exercise, actions, toggleConfirmationDialogOpen]);

    const handleDeleteRequest = useCallback(exercise => {
        setExercise(exercise);
        toggleConfirmationDialogOpen(true);
    }, []);

    const handleReorder = useCallback(exercises => {
        onReorder({
            _exercises: exercises.map(e => e.id)
        });
    }, [onReorder]);

    return (
        <PageSection
            title="Упражнения"
            actions={[{
                key: 'add',
                icon: 'add',
                title: 'Добавить упражнение',
                onClick: handleCreate
            }]}
            compact
            plain
        >

            <ExercisesList
                exercises={exercises}
                onReorder={handleReorder}
                onDelete={handleDeleteRequest}
            />

            <FormDialog
                title="Новое упражнение"
                open={isFormOpen}
                onClose={toggleFormOpen}
            >
                <ExerciseForm
                    id="exercise-form"
                    onSubmit={handleCreate}
                />
            </FormDialog>

            <ConfirmationDialog
                title="Удалить упражнение?"
                message={exercise && `Упражнение "${exercise.id}" будет удалено без возможности восстановления.`}
                open={isConfirmationDialogOpen}
                onConfirm={handleDelete}
                onClose={toggleConfirmationDialogOpen}
            />
        </PageSection>
    );
}